<template>
  <div class="entry-content container">
    <div class="entry-content__content">
      <b-row>
        <b-col sm="3">
          Social media
        </b-col>
        <b-col sm="9">
          <p v-html="content"></p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntryContent",
  props: {
    content: String
  },
  methods: {
    //
  }
};
</script>

<style lang="sass">
.entry-content
  position: relative
  z-index: 2
  margin-top: -4rem
  margin-bottom: 4rem
  padding: 6rem 4rem
  background: white
  box-shadow: 0 3px 36px rgba(0, 0, 0, 0.05)
  &__content
    max-width: 85%
    img
      width: 100%
      padding: 2rem 0
  @media screen and (max-width: 502px)
    margin-bottom: 0
    padding: 6rem 2rem
    &__content
      max-width: 100%
</style>
